import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Main from './components/Main';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Etc from './components/Etc';
import { useRef } from 'react';

function App() {
  const skillsRef = useRef(null); // Skills 섹션으로 스크롤 이동할 ref
  const projectRef = useRef(null);

  return (
    <div className="App">
      <Header skillsRef={skillsRef} projectRef={projectRef}/> {/* Header에 ref 전달 */}
      <Main />
      <Skills ref={skillsRef} /> {/* Skills 컴포넌트에 ref 연결 */}
      <Projects ref={projectRef} />
      <Etc />
    </div>
  );
}

export default App;
